import { IWorkspaceAction } from '../../@types/workspaceTypes';
import DocumentModal2 from '../../components/modals/DocumentModal2';
import { WorkspaceActionHeader } from '../../components/ActionButtons/ActionHeader';
import React, { ReactElement, useContext, useState } from 'react';
import ModalContext from '../../components/Context/ModalContext';
import WorkspaceContext from '../../components/Context/WorkspaceContext';
import { SalesCredit, SalesReturnNoteDocument } from '../../graphql/entities';
import { SalesCreditActions } from './SalesCreditActions';

export const workspaceActionsForPermissions: Array<IWorkspaceAction> = [
  { actionReference: SalesCreditActions.PrintCredit },
  { actionReference: SalesCreditActions.PrintSalesReturnNote },
];

export const useSalesCreditWorkspaceActions: () => [Array<IWorkspaceAction<SalesCreditActions>>, ReactElement] = () => {
  const [printCreditModalState, setPrintCreditModalState] = useState<{ modalOpen: boolean }>({ modalOpen: false });
  const [printReturnNoteModalState, setPrintReturnNoteModalState] = useState<{ modalOpen: boolean }>({
    modalOpen: false,
  });

  const { reloadData, selectionState } = useContext(WorkspaceContext);

  return [
    [
      {
        key: 'printCredits',
        text: 'Print Credits',
        onClick: () => setPrintCreditModalState({ modalOpen: true }),
        actionReference: SalesCreditActions.PrintCredit,
        header: WorkspaceActionHeader.REPORTS,
      },
      {
        key: 'printReturnNotes',
        text: 'Print Return Notes',
        onClick: () => setPrintReturnNoteModalState({ modalOpen: true }),
        actionReference: SalesCreditActions.PrintSalesReturnNote,
        header: WorkspaceActionHeader.REPORTS,
      },
    ],
    <>
      <ModalContext.Provider
        value={{
          onClose: () => {
            setPrintCreditModalState((previousState) => ({ ...previousState, modalOpen: false }));
            reloadData?.();
          },
        }}
      >
        <DocumentModal2
          modalOpen={printCreditModalState.modalOpen}
          multiValue={true}
          entity={SalesCredit}
          useCustomerDefaults={true}
          title="Print Sales Credit"
          modalWrapper={true}
          type={'salesCredits'}
          count={selectionState.count}
        />
      </ModalContext.Provider>
      <ModalContext.Provider
        value={{
          onClose: () => {
            setPrintReturnNoteModalState((previousState) => ({ ...previousState, modalOpen: false }));
            reloadData?.();
          },
        }}
      >
        <DocumentModal2
          modalOpen={printReturnNoteModalState.modalOpen}
          multiValue={true}
          entity={SalesReturnNoteDocument}
          useCustomerDefaults={true}
          title="Print Return Note"
          modalWrapper={true}
          type={'salesCredits'}
          count={selectionState.count}
        />
      </ModalContext.Provider>
    </>,
  ];
};
